@import '@styles/colors.scss';

.caption {
    font-family: var(--font-mono);
    font-size: 10px;
    color: var(--text-dim);
    letter-spacing: 0.1em;
    text-transform: uppercase;
    padding-bottom: 14px;
    border-bottom: 1px solid var(--border);
    width: 100%;
    margin: 0;
    line-height: 1.4;
}
